import React from "react";
import { Form, Checkbox } from "antd";

const CustomCheckbox = ({
  label,
  name,
  options,
  defaultValue,
  errorMessage,
  required = false,
  onChange,
  isModalForm,
  ...rest
}) => {
  return (
    <Form.Item
      label={label}
      className={"mb-2"}
      name={name}
      initialValue={defaultValue}
      rules={[{ required: required, message: `${label} is required` }]}
      validateStatus={errorMessage ? "error" : ""}
      help={errorMessage}
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
    >
      <Checkbox.Group
        options={options}
        onChange={onChange}
        {...rest}
        className={`grid ${
          isModalForm
            ? "grid-cols-1 min-[300px]:grid-cols-2 min-[420px]:grid-cols-3 min-[550px]:grid-cols-4"
            : "grid-cols-1 min-[380px]:grid-cols-2 min-[500px]:grid-cols-3 sm:grid-cols-4 min-[992px]:grid-cols-6 min-[1150px]:grid-cols-8"
        } items-center gap-3`}
      />
    </Form.Item>
  );
};

export default CustomCheckbox;
